import 'react';
import { Box, Skeleton, Stack } from '@mui/material';

interface FormSkeletonProps {
  rows?: number;
  showTitle?: boolean;
}

export function FormSkeleton({ rows = 3, showTitle = true }: FormSkeletonProps) {
  return (
    <Box sx={{ pt: 1 }}>
      {Array.from({ length: rows }).map((_, index) => (
        <Box
          key={index}
          sx={{
            mb: 2,
            p: 2,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
              
          }}
        >
          {showTitle && (
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="text" width="30%" height={32} />
            </Stack>
          )}
          <Stack spacing={2}>
            <Skeleton variant="rectangular" height={56} />
            <Stack direction="row" spacing={2}>
              <Skeleton variant="rectangular" height={56} sx={{ flex: 1 }} />
              <Skeleton variant="rectangular" height={56} sx={{ flex: 1 }} />
            </Stack>
            <Skeleton variant="rectangular" height={56} />
          </Stack>
        </Box>
      ))}
    </Box>
  );
}

export function CompactFormSkeleton({ rows = 2 }: { rows?: number }) {
  return (
    <Box sx={{ pt: 1 }}>
      <Stack spacing={2}>
        {Array.from({ length: rows }).map((_, index) => (
          <Box key={index}>
            <Skeleton variant="text" width="20%" height={24} sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" height={56} />
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
